<template>
  <div class="feature-block">
    <div class="feature-block__header">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <CIcon
            name="cipInfo"
            size="sm"
            class="mr-2 feature-block__help"
            v-c-tooltip="{
              content: $pgettext('features.price_lock_after_sale', 'Prevent price modifications after the first completed order. Once a sale is made, prices will be locked.'),
              placement: 'top',
              appendToBody: true
            }"
          />
          <span class="feature-block__title" v-translate translate-context="features.price_lock_after_sale">
            Price Lock After Sale
          </span>
        </div>
        <CSwitch
          color="primary"
          variant="3d"
          size="sm"
          :checked="localEnabled"
          @update:checked="localEnabled = $event"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeaturePriceLockAfterSale',
  props: {
    config: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      localEnabled: false
    }
  },
  watch: {
    config: {
      handler() {
        this.reset()
      },
      immediate: true
    }
  },
  methods: {
    reset() {
      this.localEnabled = this.config?.enabled === true
    },
    getConfig() {
      return {
        enabled: this.localEnabled
      }
    }
  }
}
</script>
